import { gql, HttpLink } from '@apollo/client'
import { ApolloClient, InMemoryCache } from '@apollo/client'
import { ApolloProvider } from '@apollo/client/react'
import useFreeze from '@onepercentio/one-ui/hooks/useFreeze'
import useRouteGalleryOrDefault, {
  useRouteGallery,
} from 'openspace/hooks/useRoutePathGallery'
import { PropsWithChildren, useEffect, useMemo, useRef } from 'react'

export function useIsGraphQlEnabled() {
  const galleryInformation = useRouteGallery()
  return !!galleryInformation?.indexing
}

/** Only used for IPO */
export const TOKEN_OWNERS = gql`
  query {
    tokens {
      holders(where: { amount_gt: "0" }) {
        wallet {
          id
        }
      }
      id
    }
  }
`

/** Used for mapping token existance with offered amount at marketplace */
export const TOKEN_BALANCE_FOR_ACCOUNTS = gql`
  query TokenBalances($wallets: [String!], $tokenIds: [String!]) {
    tokenHolders(where: { wallet_in: $wallets, token_: { id_in: $tokenIds } }) {
      amount
      token {
        id
      }
      wallet {
        id
      }
    }
  }
`

export const SALES_AMOUNT = gql`
  query SaleAmount($ids: [String!]) {
    sales(where: { id_in: $ids }) {
      id
      sold
    }
  }
`

const DEFAULT_GRAPHQL_CLIENT = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: undefined,
  }),
})

export function GraphqlProvider({ children }: PropsWithChildren) {
  const galleryInformation = useRouteGalleryOrDefault()
  useEffect(() => {
    if (galleryInformation?.indexing) {
      const { graphName, graphVersion = 'v0.0.1' } = galleryInformation.indexing
      const oldLink = DEFAULT_GRAPHQL_CLIENT.link
      DEFAULT_GRAPHQL_CLIENT.setLink(
        new HttpLink({
          uri: process.env
            .REACT_APP_GRAPHQL_GRAPH_URL!.replace(':graphName', graphName)
            .replace(':graphVersion', graphVersion),
        })
      )
      DEFAULT_GRAPHQL_CLIENT.refetchObservableQueries()
      return () => DEFAULT_GRAPHQL_CLIENT.setLink(oldLink)
    }
  }, [galleryInformation])

  return (
    <ApolloProvider client={DEFAULT_GRAPHQL_CLIENT}>{children}</ApolloProvider>
  )
}
